import * as React from 'react';
import { useManager } from '../components';
export var useSignalSubscriber = function (subscription) {
    var manager = useManager();
    React.useEffect(function () {
        manager.subscribe(subscription);
        return function () { return manager.unsubscribe(subscription); };
    }, []);
};
//# sourceMappingURL=use-signal-subscriber.js.map